import React, { useEffect, useMemo, useState } from "react";
import empaticaLogo from "../recursos/empatica-hor.png";
import "../estilos/DeviceApiDocs.css";

const DEFAULT_BASE_URL = "http://IP_DEL_CAJERO:5188";

const endpointGroups = [
  ["overview", "Empezar", "Overview"],
  ["quickstart", "Empezar", "Quickstart"],
  ["authentication", "Empezar", "Autenticación"],
  ["downloads", "Empezar", "Recursos de prueba"],

  ["login", "Autenticación", "Iniciar sesión"],
  ["me", "Autenticación", "Sesión actual"],
  ["logout", "Autenticación", "Cerrar sesión"],

  ["noncash", "Pagos", "Venta sin efectivo"],

  ["charge", "Cobro en efectivo", "Iniciar cobro"],
  ["status", "Cobro en efectivo", "Consultar operación"],
  ["finalize", "Cobro en efectivo", "Finalizar operación"],
  ["cancel", "Cobro en efectivo", "Cancelar operación"],

  ["device", "Dispositivo", "Estado del cajero"],

  ["mixed", "Guías", "Pagos mixtos"],
  ["reverse", "Guías", "API/REST inversa"],

  ["operationstatus", "Referencia", "Estados de operación"],
  ["responses", "Referencia", "Formato de respuesta"],
  ["errors", "Referencia", "Errores"]
];

const endpoints = {
  login: {
    group: "Autenticación",
    title: "Iniciar sesión",
    method: "POST",
    path: "/api/auth/login",
    auth: false,
    description:
      "Inicia una sesión en Device API. La sesión se entrega como cookie HttpOnly ecc_session.",
    body: {
      username: "admin",
      password: "admin123"
    },
    fields: [
      ["username", "String", "Sí", "Usuario de la plataforma."],
      ["password", "String", "Sí", "Contraseña del usuario."]
    ],
    responseExample: {
      ok: true,
      codigo: "LOGIN_OK",
      mensaje: "Inicio de sesión correcto.",
      data: {
        user: {
          username: "admin",
          rol: "DUENO",
          permisos: ["*"]
        }
      }
    }
  },

  me: {
    group: "Autenticación",
    title: "Sesión actual",
    method: "GET",
    path: "/api/auth/me",
    auth: true,
    description:
      "Consulta el usuario asociado a la sesión actual.",
    body: {},
    fields: [],
    responseExample: {
      ok: true,
      codigo: "200",
      mensaje: "OK",
      data: {
        user: {
          username: "admin",
          rol: "DUENO"
        }
      }
    }
  },

  logout: {
    group: "Autenticación",
    title: "Cerrar sesión",
    method: "POST",
    path: "/api/auth/logout",
    auth: true,
    description: "Cierra la sesión actual.",
    body: {},
    fields: [],
    responseExample: {
      ok: true,
      codigo: "200",
      mensaje: "Sesión cerrada.",
      data: null
    }
  },

  noncash: {
    group: "Pagos",
    title: "Registrar venta sin efectivo",
    method: "POST",
    path: "/api/cash/non-cash-sale",
    auth: true,
    description:
      "Registra una venta pagada con tarjeta, transferencia, vales u otro medio que no pasa físicamente por el cajero. La respuesta HTTP confirma el registro.",
    body: {
      totalVenta: 150.5,
      montoTarjeta: 0,
      montoTransferencia: 150.5,
      montoVales: 0,
      montoOtros: 0,
      ventaIdExterna: "PEDIDO-0001",
      cveTransaccion: "TX-PEDIDO-0001",
      conceptoOperacion: "Pedido en línea #0001",
      observaciones: ""
    },
    fields: [
      ["totalVenta", "Decimal", "No", "Total de la venta. Si se omite, se calcula sumando los medios."],
      ["montoTarjeta", "Decimal", "No", "Monto pagado con tarjeta. Requiere pago aprobado previamente por una terminal vinculada."],
      ["montoTransferencia", "Decimal", "No", "Monto pagado por transferencia."],
      ["montoVales", "Decimal", "No", "Monto pagado con vales."],
      ["montoOtros", "Decimal", "No", "Otros medios de pago."],
      ["ventaIdExterna", "String", "No", "Folio o identificador de tu sistema."],
      ["cveTransaccion", "String", "No", "Clave idempotente para evitar registros duplicados."],
      ["conceptoOperacion", "String", "No", "Concepto libre para reportes."],
      ["observaciones", "String", "No", "Observaciones libres."]
    ],
    responseExample: {
      ok: true,
      codigo: "NON_CASH_SALE_REGISTERED",
      mensaje: "Venta sin efectivo registrada para reportes.",
      data: {
        ok: true,
        codigo: "NON_CASH_SALE_REGISTERED",
        idOperacion: "a1b2c3d4...",
        montoOperacion: 150.5,
        montoIngresado: 0,
        diferencia: 0,
        mediosPago: {
          efectivo: 0,
          terminal: 0,
          transferencia: 150.5,
          vales: 0,
          otros: 0
        }
      }
    }
  },

  charge: {
    group: "Cobro en efectivo",
    title: "Iniciar cobro",
    method: "POST",
    path: "/api/cash/charge",
    auth: true,
    description:
      "Inicia un cobro físico en el cajero. El monto debe expresarse en pesos enteros y la operación continúa de forma asíncrona.",
    body: {
      monto: 200,
      moneda: "MXN",
      ventaIdExterna: "PEDIDO-0002",
      idOperacion: ""
    },
    fields: [
      ["monto", "Integer", "Sí", "Importe en pesos enteros. Mínimo 1."],
      ["moneda", "String", "No", "Moneda de la operación. Normalmente MXN."],
      ["ventaIdExterna", "String", "No", "Referencia o folio de tu sistema."],
      ["idOperacion", "String", "No", "Puedes enviarlo tú o permitir que el servidor lo genere."]
    ],
    responseExample: {
      ok: true,
      codigo: "200",
      data: {
        idOperacion: "COB-20260724...",
        estadoOperacion: "1",
        montoOperacion: 200
      }
    }
  },

  status: {
    group: "Cobro en efectivo",
    title: "Consultar operación",
    method: "POST",
    path: "/api/cash/operation/status",
    auth: true,
    description:
      "Consulta el avance de un cobro. Durante una operación en efectivo realiza poll aproximadamente cada 1–2 segundos hasta llegar a un estado terminal.",
    body: {
      idOperacion: "COB-20260724...",
      accionInicial: "COBRO_INICIO",
      accionFinal: "COBRO"
    },
    fields: [
      ["idOperacion", "String", "Sí", "Identificador de la operación."],
      ["accionInicial", "String", "No", "Para cobros: COBRO_INICIO."],
      ["accionFinal", "String", "No", "Para cobros: COBRO."]
    ],
    responseExample: {
      ok: true,
      codigo: "200",
      data: {
        operation: {
          idOperacion: "COB-20260724...",
          estadoOperacion: "2",
          montoOperacion: 200,
          montoIngresado: 200,
          diferencia: 0
        }
      }
    }
  },

  finalize: {
    group: "Cobro en efectivo",
    title: "Finalizar operación",
    method: "POST",
    path: "/api/cash/operation/finalize",
    auth: true,
    description:
      "Cierra y registra la operación en reportes, arqueo y ticket. Debe ejecutarse cuando el estado de la operación ya sea terminal.",
    body: {
      idOperacion: "COB-20260724...",
      accionInicial: "COBRO_INICIO",
      accionFinal: "COBRO",
      moneda: "MXN",
      monto: 200,
      montoEfectivo: 200,
      montoTarjeta: 0,
      montoTransferencia: 0,
      montoVales: 0,
      montoOtros: 0
    },
    fields: [
      ["idOperacion", "String", "Sí", "Identificador de la operación."],
      ["accionInicial", "String", "No", "Para cobros: COBRO_INICIO."],
      ["accionFinal", "String", "No", "Para cobros: COBRO."],
      ["moneda", "String", "No", "Moneda de la operación."],
      ["monto", "Decimal", "No", "Monto esperado de la operación."],
      ["montoEfectivo", "Decimal", "No", "Monto de efectivo reportado para la operación."],
      ["montoTarjeta", "Decimal", "No", "Parte pagada con tarjeta en un pago mixto."],
      ["montoTransferencia", "Decimal", "No", "Parte pagada por transferencia."],
      ["montoVales", "Decimal", "No", "Parte pagada con vales."],
      ["montoOtros", "Decimal", "No", "Parte pagada con otros medios."]
    ],
    responseExample: {
      ok: true,
      codigo: "OPERATION_FINALIZED_OK",
      data: {
        action: "COBRO",
        operation: {
          idOperacion: "COB-20260724...",
          estadoOperacion: "2",
          montoOperacion: 200,
          montoIngresado: 200,
          diferencia: 0,
          mediosPago: {
            efectivo: 200,
            terminal: 0,
            transferencia: 0,
            vales: 0,
            otros: 0
          }
        }
      }
    }
  },

  cancel: {
    group: "Cobro en efectivo",
    title: "Cancelar operación",
    method: "POST",
    path: "/api/cash/operation/cancel",
    auth: true,
    description:
      "Cancela una operación en curso, por ejemplo cuando el cliente decide no continuar con el pago.",
    body: {
      idOperacion: "COB-20260724..."
    },
    fields: [
      ["idOperacion", "String", "Sí", "Identificador de la operación a cancelar."]
    ],
    responseExample: {
      ok: true,
      codigo: "200",
      mensaje: "Operación cancelada.",
      data: {
        idOperacion: "COB-20260724...",
        estadoOperacion: "4"
      }
    }
  },

  device: {
    group: "Dispositivo",
    title: "Estado del cajero",
    method: "GET",
    path: "/api/cash/device-status",
    auth: true,
    description:
      "Consulta la disponibilidad del dispositivo antes de iniciar una operación.",
    body: {},
    query: {
      providerCode: "ATM-LOCAL-001"
    },
    fields: [
      ["providerCode", "String", "No", "Código del proveedor o dispositivo."]
    ],
    responseExample: {
      ok: true,
      codigo: "DEVICE_STATUS_OK",
      data: {
        estadoDispositivo: 1,
        descripcionDispositivo: "OK MOCK"
      }
    }
  }
};

export default function DeviceApiDocs() {
  const [page, setPage] = useState(() => resolvePage(window.location.pathname));
  const [baseUrl, setBaseUrl] = useState(DEFAULT_BASE_URL);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onPop = () => setPage(resolvePage(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("deviceDocsMenuOpen");
    } else {
      document.body.classList.remove("deviceDocsMenuOpen");
    }

    return () => document.body.classList.remove("deviceDocsMenuOpen");
  }, [menuOpen]);

  useEffect(() => {
    document.body.classList.add("deviceApiDocsPage");
    return () => document.body.classList.remove("deviceApiDocsPage");
  }, []);

  const navigate = (key) => {
    const suffix = routeFor(key);
    const url = suffix
      ? `/developers/device-api/${suffix}`
      : "/developers/device-api";

    window.history.pushState({}, "", url);
    setPage(key);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="deviceDocs">
      <header className="docsTopbar">
        <div className="topbarLeft">
          <button
            className="mobileMenuButton"
            onClick={() => setMenuOpen(true)}
            aria-label="Abrir menú"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="docsBrand" onClick={() => navigate("overview")}>
            <img src={empaticaLogo} alt="Empática" />
            <span className="brandDivider" />
            <div>
              <strong>Device API</strong>
              <span>Developer Docs</span>
            </div>
          </div>
        </div>

        <div className="docsEnvironment">
          <div className="environmentField baseUrlField">
            <label>URL DEL CAJERO PARA EJEMPLOS</label>
            <input
              value={baseUrl}
              onChange={(e) => setBaseUrl(cleanBaseUrl(e.target.value))}
              placeholder="http://192.168.1.100:5188"
            />
          </div>
        </div>
      </header>

      <Sidebar
        page={page}
        navigate={navigate}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      <div className="docsShell">
        <main className="docsMain">
          {page === "overview" && <Overview navigate={navigate} />}
          {page === "quickstart" && <Quickstart navigate={navigate} baseUrl={baseUrl} />}
          {page === "authentication" && <Authentication />}
          {page === "downloads" && <Downloads />}
          {page === "mixed" && <MixedPayments navigate={navigate} />}
          {page === "reverse" && <ReverseApi />}
          {page === "operationstatus" && <OperationStatusReference />}
          {page === "responses" && <ResponseReference />}
          {page === "errors" && <ErrorsReference />}

          {endpoints[page] && (
            <EndpointPage
              key={page}
              endpoint={endpoints[page]}
              baseUrl={baseUrl}
            />
          )}
        </main>
      </div>
    </div>
  );
}

function Sidebar({ page, navigate, menuOpen, setMenuOpen }) {
  const groups = [];
  for (const item of endpointGroups) {
    const [key, group, label] = item;
    let g = groups.find((x) => x.name === group);
    if (!g) {
      g = { name: group, items: [] };
      groups.push(g);
    }
    g.items.push({ key, label });
  }

  return (
    <>
      <button
        className={`sidebarBackdrop ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(false)}
        aria-label="Cerrar menú"
      />

      <aside className={`docsSidebar ${menuOpen ? "open" : ""}`}>
        <div className="mobileSidebarHeader">
          <div>
            <strong>Device API</strong>
            <span>Documentación</span>
          </div>
          <button
            className="closeSidebarButton"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar menú"
          >
            ×
          </button>
        </div>

        <div className="sidebarInner">
          {groups.map((group) => (
            <div className="navGroup" key={group.name}>
              <div className="navGroupTitle">{group.name}</div>
              {group.items.map((item) => (
                <button
                  key={item.key}
                  className={`navItem ${page === item.key ? "active" : ""}`}
                  onClick={() => navigate(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      </aside>
    </>
  );
}

function Overview({ navigate }) {
  return (
    <div className="contentPage overviewPage">
      <span className="sectionKicker">DEVICE API</span>
      <h1>Controla el pago directamente desde el cajero.</h1>
      <p className="lead">
        Device API permite que tu sistema se comunique directamente con una instancia de
        Empática ATM Cash Control en la red local. Puedes registrar pagos sin efectivo,
        iniciar cobros físicos, consultar su avance y conocer el estado del dispositivo.
      </p>

      <div className="architectureHero">
        <FlowNode title="Tu sistema" subtitle="ERP · POS · App" />
        <FlowArrow />
        <div className="cashierApiNode">
          <span className="cashierApiLabel">Cajero</span>
          <div className="cashierApiInner">
            <strong>Device API</strong>
            <span>Servicio local del cajero · puerto 5188</span>
          </div>
          <small>Efectivo + operación del dispositivo</small>
        </div>
      </div>

      <div className="overviewCards">
        <button onClick={() => navigate("quickstart")}>
          <span>01</span>
          <strong>Quickstart</strong>
          <p>Prueba login y registra tu primera operación.</p>
        </button>
        <button onClick={() => navigate("noncash")}>
          <span>02</span>
          <strong>Venta sin efectivo</strong>
          <p>Registra tarjeta, transferencia, vales u otros medios.</p>
        </button>
        <button onClick={() => navigate("charge")}>
          <span>03</span>
          <strong>Cobro en efectivo</strong>
          <p>Inicia el flujo crear → consultar → finalizar.</p>
        </button>
      </div>

      <div className="infoBanner">
        <div className="infoIcon">i</div>
        <div>
          <strong>Conexión local</strong>
          <p>
            Device API se ejecuta en el mismo entorno del cajero y normalmente expone el
            puerto <code>5188</code>. Tu sistema debe poder alcanzar esa IP dentro de la red local.
          </p>
        </div>
      </div>
    </div>
  );
}

function Quickstart({ navigate, baseUrl }) {
  const curl = `# 1. Login
curl -c cookies.txt -X POST ${baseUrl}/api/auth/login \\
  -H 'Content-Type: application/json' \\
  -d '{"username":"admin","password":"admin123"}'

# 2. Registrar una venta sin efectivo
curl -b cookies.txt -X POST ${baseUrl}/api/cash/non-cash-sale \\
  -H 'Content-Type: application/json' \\
  -d '{"totalVenta":150.50,"montoTransferencia":150.50,"ventaIdExterna":"PEDIDO-0001"}'`;

  return (
    <div className="contentPage">
      <span className="sectionKicker">EMPEZAR</span>
      <h1>Tu primera operación en minutos.</h1>
      <p className="lead">
        Autentícate, conserva la sesión y ejecuta una operación contra el cajero.
      </p>

      <div className="stepList">
        <GuideStep number="1" title="Define la Base URL">
          Usa la IP del cajero dentro de la red local, normalmente
          <code> http://IP_DEL_CAJERO:5188</code>. El valor <code>localhost</code> solo es válido
          cuando el cliente de pruebas se ejecuta en el mismo equipo que Device API.
        </GuideStep>

        <GuideStep number="2" title="Inicia sesión">
          Ejecuta <button className="textLink" onClick={() => navigate("login")}>POST /api/auth/login</button>.
          La sesión se mantiene mediante la cookie <code>ecc_session</code> o el header
          <code> X-ECC-Session</code>.
        </GuideStep>

        <GuideStep number="3" title="Ejecuta una operación">
          Para empezar sin hardware físico puedes registrar una
          <button className="textLink" onClick={() => navigate("noncash")}> venta sin efectivo</button>.
        </GuideStep>
      </div>

      <div className="callout">
        <strong>¿Quieres probarlo?</strong>
        <span>
          Usa la colección de Postman o los ejemplos descargables desde
          <button className="textLink" onClick={() => navigate("downloads")}> Recursos de prueba</button>.
          Ejecútalos desde un equipo que tenga acceso a la misma red del cajero.
        </span>
      </div>

      <h2>Ejemplo mínimo</h2>
      <pre className="wideCode"><code>{curl}</code></pre>
    </div>
  );
}

function Authentication() {
  return (
    <div className="contentPage">
      <span className="sectionKicker">AUTENTICACIÓN</span>
      <h1>Sesión local del cajero.</h1>
      <p className="lead">
        Device API utiliza una sesión de usuario real de Empática ATM Cash Control.
        Primero inicia sesión con usuario y contraseña.
      </p>

      <div className="authModes">
        <div className="authCard">
          <span className="authBadge">Opción A</span>
          <strong>Cookie ecc_session</strong>
          <p>
            Recomendada para Postman, navegador o clientes HTTP con cookie jar.
            La cookie es HttpOnly y el cliente la reenvía automáticamente.
          </p>
        </div>

        <div className="authCard">
          <span className="authBadge">Opción B</span>
          <strong>X-ECC-Session</strong>
          <p>
            Recomendada para integraciones servidor-a-servidor. Envía el valor de
            la sesión como header en cada solicitud.
          </p>
        </div>
      </div>

      <div className="callout warning">
        <strong>Permisos</strong>
        <span>
          Los endpoints requieren permisos como <code>CASH_CHARGE</code>,
          <code>CASH_QUERY</code>, <code>CASH_CANCEL</code> o <code>CASH_READ</code>.
          Usuarios DUENO / ADMIN / OWNER tienen acceso total.
        </span>
      </div>
    </div>
  );
}

function Downloads() {
  const resources = [
    {
      title: "Colección Postman",
      desc: "Endpoints de Device API listos para importar en Postman.",
      href: "/developers/device-api/downloads/Empatica.ATM.CashControl.postman_collection.json",
      action: "Descargar colección"
    },
    {
      title: "Ambiente Postman · Local",
      desc: "Variables para trabajar contra una instancia Device API en red local.",
      href: "/developers/device-api/downloads/Empatica.ATM.CashControl.Local.postman_environment.json",
      action: "Descargar ambiente"
    },
    {
      title: "Ambiente Postman · Sandbox",
      desc: "Variables incluidas por el paquete para trabajar con el servidor virtual.",
      href: "/developers/device-api/downloads/Empatica.ATM.CashControl.Sandbox.postman_environment.json",
      action: "Descargar ambiente"
    },
    {
      title: "Ejemplos de integración",
      desc: "Ejemplos en cURL, JavaScript, Python, PHP y C#.",
      href: "/developers/device-api/downloads/DeviceAPI-Ejemplos.zip",
      action: "Descargar ejemplos"
    },
    {
      title: "Sandbox local",
      desc: "Servidor virtual incluido en el paquete para realizar pruebas sin un cajero físico.",
      href: "/developers/device-api/downloads/DeviceAPI-Sandbox.zip",
      action: "Descargar sandbox"
    },
    {
      title: "Kit de pruebas completo",
      desc: "Postman, ambientes, ejemplos, simulador y sandbox en un solo archivo.",
      href: "/developers/device-api/downloads/DeviceAPI-Kit-Pruebas.zip",
      action: "Descargar kit"
    }
  ];

  return (
    <div className="contentPage">
      <span className="sectionKicker">EMPEZAR</span>
      <h1>Recursos de prueba</h1>
      <p className="lead">
        Device API vive en la red local del cajero. Por eso las pruebas deben ejecutarse
        desde un equipo que pueda comunicarse directamente con la IP del cajero.
      </p>

      <div className="networkExample">
        <div>
          <span>Tu equipo de pruebas</span>
          <strong>Postman / App / Backend</strong>
        </div>
        <FlowArrow />
        <div>
          <span>Misma red local</span>
          <strong>192.168.1.x</strong>
        </div>
        <FlowArrow />
        <div className="networkCashier">
          <span>Cajero</span>
          <strong>Device API :5188</strong>
        </div>
      </div>

      <div className="callout warning">
        <strong>Sobre localhost</strong>
        <span>
          <code>localhost</code> siempre representa la computadora donde estás ejecutando
          Postman, cURL, tu aplicación o tu navegador. Para comunicarte con otro cajero de
          la red debes usar su IP, por ejemplo <code>http://192.168.1.50:5188</code>.
        </span>
      </div>

      <div className="downloadGrid">
        {resources.map((resource) => (
          <a
            key={resource.title}
            className="downloadCard"
            href={resource.href}
            download
          >
            <div className="downloadIcon">↓</div>
            <div>
              <strong>{resource.title}</strong>
              <p>{resource.desc}</p>
              <span>{resource.action} →</span>
            </div>
          </a>
        ))}
      </div>

      <div className="callout success">
        <strong>Recomendado para empezar</strong>
        <span>
          Importa primero la <b>Colección Postman</b> y el ambiente <b>Local</b>.
          Cambia la variable de Base URL por la IP real del cajero y ejecuta el login.
        </span>
      </div>
    </div>
  );
}

function EndpointPage({ endpoint, baseUrl }) {
  const [lang, setLang] = useState("curl");

  const requestUrl = useMemo(
    () => buildUrl(baseUrl, endpoint.path, endpoint.query || {}),
    [baseUrl, endpoint.path, endpoint.query]
  );

  const snippet = generateSnippet(
    lang,
    endpoint,
    requestUrl,
    endpoint.body || {},
    "TU_SESION"
  );

  const hasBody =
    endpoint.method !== "GET" &&
    Object.keys(endpoint.body || {}).length > 0;

  const hasQuery = Object.keys(endpoint.query || {}).length > 0;

  return (
    <div className="endpointDocLayout endpointDocLayoutStable">
      <section className="endpointContent endpointContentStable">
        <span className="sectionKicker">{endpoint.group.toUpperCase()}</span>
        <h1>{endpoint.title}</h1>

        <div className="endpointPath">
          <span className={`method ${endpoint.method.toLowerCase()}`}>
            {endpoint.method}
          </span>
          <code>{endpoint.path}</code>
        </div>

        <p className="lead small">{endpoint.description}</p>

        {endpoint.auth && (
          <div className="authInline">
            <LockIcon />
            Requiere sesión <code>ecc_session</code> o <code>X-ECC-Session</code>.
          </div>
        )}

        <h2>Parámetros</h2>
        {endpoint.fields.length ? (
          <div className="paramsTable">
            <div className="paramsHead">
              <span>Campo</span>
              <span>Tipo</span>
              <span>Requerido</span>
              <span>Descripción</span>
            </div>

            {endpoint.fields.map(([n, t, r, d]) => (
              <ParamRow
                key={n}
                name={n}
                type={t}
                req={r}
                desc={d}
              />
            ))}
          </div>
        ) : (
          <div className="emptyParams">
            Este endpoint no requiere parámetros propios.
          </div>
        )}

        {hasQuery && (
          <>
            <h2>Query parameters</h2>
            <pre className="requestBodyStatic">
              <code>
                {Object.entries(endpoint.query)
                  .map(([key, value]) => `${key}=${value}`)
                  .join("\n")}
              </code>
            </pre>
          </>
        )}

        {hasBody && (
          <>
            <h2>Request body</h2>
            <pre className="requestBodyStatic">
              <code>
                {JSON.stringify(endpoint.body, null, 2)}
              </code>
            </pre>
          </>
        )}

        <div className="localTestNote">
          <strong>Para probar este endpoint</strong>
          <p>
            Copia uno de los ejemplos de solicitud y ejecútalo desde un equipo
            que tenga acceso a la misma red local del cajero, o usa los archivos
            disponibles en <a href="/developers/device-api/resources">Recursos de prueba</a>.
          </p>
        </div>

        <h2>Respuesta de ejemplo</h2>
        <pre className="responseExample">
          <code>
            {JSON.stringify(endpoint.responseExample, null, 2)}
          </code>
        </pre>

        <div className="mobileRequestExample">
          <RequestExamplePanel
            lang={lang}
            setLang={setLang}
            requestUrl={requestUrl}
            snippet={snippet}
          />
        </div>
      </section>

      <aside className="requestExampleAside desktopRequestExample">
        <RequestExamplePanel
          lang={lang}
          setLang={setLang}
          requestUrl={requestUrl}
          snippet={snippet}
        />
      </aside>
    </div>
  );
}

function RequestExamplePanel({ lang, setLang, requestUrl, snippet }) {
  return (
    <div className="examplePanel">
      <div className="examplePanelHeader">
        <div>
          <span className="playLabel">EJEMPLO DE SOLICITUD</span>
          <code>{requestUrl}</code>
        </div>

        <span className="noLiveBadge">Solo ejemplo</span>
      </div>

      <div className="langTabs">
        {["curl", "javascript", "csharp", "python", "php", "java"].map((x) => (
          <button
            className={lang === x ? "active" : ""}
            onClick={() => setLang(x)}
            key={x}
          >
            {labelLang(x)}
          </button>
        ))}
      </div>

      <pre className="codeBlock">
        <code>{snippet}</code>
      </pre>

      <div className="exampleAsideNote">
        <strong>No ejecuta solicitudes</strong>
        <span>
          Copia el ejemplo y ejecútalo desde Postman, tu aplicación o un equipo
          que tenga acceso directo a la red local del cajero.
        </span>
      </div>
    </div>
  );
}

function MixedPayments({ navigate }) {
  return (
    <div className="contentPage">
      <span className="sectionKicker">GUÍAS</span>
      <h1>Pagos mixtos.</h1>
      <p className="lead">
        Device API permite registrar una venta donde una parte pasa físicamente por el cajero
        y otra ya fue cobrada por tarjeta, transferencia, vales u otro medio.
      </p>

      <div className="flowSteps">
        <FlowStep n="1" title="Cobra el efectivo">
          Usa <button className="textLink" onClick={() => navigate("charge")}>/api/cash/charge</button>
          únicamente por la parte en efectivo.
        </FlowStep>
        <FlowStep n="2" title="Espera el estado final">
          Consulta <button className="textLink" onClick={() => navigate("status")}>operation/status</button>
          hasta obtener estado 2 o 3.
        </FlowStep>
        <FlowStep n="3" title="Cierra la venta completa">
          En <button className="textLink" onClick={() => navigate("finalize")}>operation/finalize</button>
          agrega los montos ya cobrados por tarjeta, transferencia, vales u otros.
        </FlowStep>
      </div>

      <div className="callout warning">
        <strong>Tarjeta</strong>
        <span>
          En <code>non-cash-sale</code>, un <code>montoTarjeta &gt; 0</code> requiere que exista
          un pago aprobado previamente por una terminal vinculada a la misma referencia.
        </span>
      </div>
    </div>
  );
}

function ReverseApi() {
  return (
    <div className="contentPage">
      <span className="sectionKicker">GUÍAS · AVANZADO</span>
      <h1>API/REST inversa.</h1>
      <p className="lead">
        Este flujo cambia la dirección de comunicación: el cajero consulta y notifica
        a tu propio backend. Estos endpoints <strong>no los expone Device API</strong>;
        son rutas que tu sistema debe implementar.
      </p>

      <div className="reverseFlow">
        <FlowNode title="Cajero" subtitle="Empática" />
        <FlowArrow />
        <FlowNode title="Tu API" subtitle="Pedidos / pagos" primary />
      </div>

      <div className="reverseEndpoints">
        <div>
          <span className="method get">GET</span>
          <code>/api/pedidos/{"{codigo}"}</code>
          <p>El cajero consulta el pedido en tu sistema.</p>
        </div>
        <div>
          <span className="method post">POST</span>
          <code>/api/pedidos/pago-confirmado</code>
          <p>El cajero confirma que el pedido fue pagado.</p>
        </div>
      </div>

      <div className="callout">
        <strong>Autenticación independiente</strong>
        <span>
          Este contrato inverso puede usar <code>X-Api-Key</code> o
          <code>Authorization: Bearer</code>. No utiliza la sesión <code>ecc_session</code>.
        </span>
      </div>
    </div>
  );
}

function OperationStatusReference() {
  const statuses = [
    ["0", "Esperando", "Esperando que el cliente empiece a ingresar efectivo.", "waiting"],
    ["1", "En proceso", "El dispositivo está recibiendo efectivo.", "processing"],
    ["2", "Pagado", "Importe exacto. Estado terminal exitoso.", "paid"],
    ["3", "Pagado con diferencia", "Pago finalizado con diferencia entre esperado e ingresado.", "difference"],
    ["4", "Cancelado", "La operación fue cancelada. Estado terminal.", "cancelled"],
    ["5", "Error", "La operación terminó con error.", "error"]
  ];

  return (
    <div className="contentPage">
      <span className="sectionKicker">REFERENCIA</span>
      <h1>Estados de operación</h1>
      <p className="lead">
        El campo <code>estadoOperacion</code> describe el ciclo de vida de un cobro físico.
      </p>

      <div className="operationStatusGrid">
        {statuses.map(([id, label, desc, cls]) => (
          <div className="operationStatusCard" key={id}>
            <span className={`opStatusId ${cls}`}>{id}</span>
            <div>
              <strong>{label}</strong>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="callout success">
        <strong>Estados finales</strong>
        <span>
          <code>2</code> y <code>3</code> son finales exitosos.
          <code>4</code> y <code>5</code> son finales sin éxito.
          Al llegar a cualquiera de ellos deja de hacer poll.
        </span>
      </div>
    </div>
  );
}

function ResponseReference() {
  return (
    <div className="contentPage">
      <span className="sectionKicker">REFERENCIA</span>
      <h1>Formato de respuesta</h1>
      <p className="lead">
        Todas las respuestas siguen un sobre consistente.
      </p>

      <pre className="wideCode"><code>{`{
  "ok": true,
  "codigo": "ALGUN_CODIGO",
  "mensaje": "Texto legible en español.",
  "data": {}
}`}</code></pre>

      <div className="definitionList">
        <Definition name="ok">Indica si la operación fue aceptada o no.</Definition>
        <Definition name="codigo">Código estable para lógica de programa.</Definition>
        <Definition name="mensaje">Texto descriptivo; puede cambiar de redacción entre versiones.</Definition>
        <Definition name="data">Resultado particular de cada endpoint.</Definition>
      </div>

      <h2>Códigos HTTP</h2>
      <div className="httpGrid">
        <HttpCode code="200" text="Éxito" />
        <HttpCode code="400" text="Solicitud inválida" />
        <HttpCode code="401" text="Credenciales inválidas" />
        <HttpCode code="403" text="Sin permiso" />
        <HttpCode code="409" text="Conflicto o precondición" />
        <HttpCode code="428" text="Autorización adicional" />
        <HttpCode code="500" text="Error interno" />
      </div>
    </div>
  );
}

function ErrorsReference() {
  const rows = [
    ["SIN_PERMISO", "403", "Sesión ausente/expirada o permiso insuficiente.", "Inicia sesión de nuevo o revisa el nivel del usuario."],
    ["LOGIN_INVALIDO", "401", "Usuario o contraseña incorrectos.", "Verifica las credenciales."],
    ["PAYMENT_MEDIA_NOT_ALLOWED", "400", "El medio de pago no está habilitado.", "Habilítalo o usa uno permitido."],
    ["TOTAL_VENTA_INVALIDO", "400", "El total de la venta es menor o igual a cero.", "Corrige el monto."],
    ["VENTA_CON_EFECTIVO_REQUIERE_CAJERO", "400", "Se intentó mandar efectivo por non-cash-sale.", "Usa /api/cash/charge."],
    ["IMPORTE_INVALIDO", "400", "El importe en efectivo no es un entero mayor o igual a 1.", "Usa pesos enteros."],
    ["CICLO_NO_ABIERTO", "409", "El cajero no tiene un ciclo abierto.", "Registra un Retiro total desde la interfaz."],
    ["DOTACION_REQUERIDA_TRAS_CORTE_TOTAL", "409", "Existe ciclo abierto pero falta dotación.", "Registra una dotación mayor a $1."],
    ["CAJERO_NO_DISPONIBLE", "409", "El cajero está ocupado.", "Consulta device-status y reintenta cuando esté libre."],
    ["CAJERO_FUERA_DE_SERVICIO_DESCUADRE", "409", "Existe un descuadre de efectivo sin resolver.", "Un autorizador debe liberar el equipo."],
    ["OPERACION_AUN_PENDIENTE", "409", "Finalize se llamó antes del cierre real.", "Continúa el poll y reintenta finalize."],
    ["NON_CASH_SALE_ALREADY_REGISTERED", "200", "La clave idempotente ya había sido registrada.", "Trátalo como éxito."],
    ["ERROR_INTERNO", "500", "Error no controlado.", "Reporta data.idErrorGlobal a soporte."]
  ];

  return (
    <div className="contentPage">
      <span className="sectionKicker">REFERENCIA</span>
      <h1>Catálogo de errores</h1>
      <p className="lead">
        Utiliza <code>codigo</code> para tu lógica de programa; no dependas del texto de
        <code> mensaje</code>.
      </p>

      <div className="errorTable">
        <div className="errorHead">
          <span>Código</span><span>HTTP</span><span>Causa</span><span>Qué hacer</span>
        </div>
        {rows.map((row) => (
          <div className="errorRow" key={row[0]}>
            <code>{row[0]}</code>
            <span className="httpBadge">{row[1]}</span>
            <span>{row[2]}</span>
            <span>{row[3]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function LockedField({ fieldKey, value, onChange, secret = false }) {
  const type = typeof value;

  return (
    <div className="payloadField">
      <div className="payloadFieldLabel">
        <code>{fieldKey}</code>
        <span>{type === "number" ? "Number" : "String"}</span>
      </div>

      <input
        type={secret ? "password" : type === "number" ? "number" : "text"}
        step={type === "number" ? "any" : undefined}
        value={value == null ? "" : value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function ParamRow({ name, type, req, desc }) {
  return (
    <div className="paramsRow">
      <code>{name}</code>
      <span>{type}</span>
      <span>{req}</span>
      <span>{desc}</span>
    </div>
  );
}

function GuideStep({ number, title, children }) {
  return (
    <div className="guideStep">
      <span>{number}</span>
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
}

function FlowStep({ n, title, children }) {
  return (
    <div className="flowStep">
      <span>{n}</span>
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
}

function FlowNode({ title, subtitle, primary = false }) {
  return (
    <div className={`flowNode ${primary ? "primary" : ""}`}>
      <strong>{title}</strong>
      <span>{subtitle}</span>
    </div>
  );
}

function FlowArrow() {
  return <span className="flowArrow">→</span>;
}

function Definition({ name, children }) {
  return (
    <div className="definition">
      <code>{name}</code>
      <span>{children}</span>
    </div>
  );
}

function HttpCode({ code, text }) {
  return (
    <div className="httpCode">
      <strong>{code}</strong>
      <span>{text}</span>
    </div>
  );
}

function LockIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function normalizeInputValue(originalValue, nextValue) {
  if (typeof originalValue === "number") {
    if (nextValue === "") return "";
    const parsed = Number(nextValue);
    return Number.isNaN(parsed) ? nextValue : parsed;
  }
  return nextValue;
}

function cleanBaseUrl(value) {
  return value.replace(/\/+$/, "");
}

function buildUrl(baseUrl, path, query) {
  const root = cleanBaseUrl(baseUrl || DEFAULT_BASE_URL);
  const params = Object.entries(query || {})
    .filter(([, value]) => value !== "" && value != null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);

  return `${root}${path}${params.length ? `?${params.join("&")}` : ""}`;
}

function pretty(value) {
  return typeof value === "string" ? value : JSON.stringify(value, null, 2);
}

function labelLang(lang) {
  return ({
    curl: "cURL",
    javascript: "JavaScript",
    csharp: "C#",
    python: "Python",
    php: "PHP",
    java: "Java"
  })[lang] || lang;
}

function generateSnippet(lang, endpoint, requestUrl, body, sessionToken) {
  const hasBody = endpoint.method !== "GET" && Object.keys(body || {}).length > 0;
  const json = JSON.stringify(body || {}, null, 2);
  const authHeader = endpoint.auth ? `X-ECC-Session: ${sessionToken}` : "";

  if (lang === "curl") {
    const lines = [`curl -X ${endpoint.method} '${requestUrl}'`];
    if (endpoint.method !== "GET") lines.push(`  -H 'Content-Type: application/json'`);
    if (endpoint.auth) lines.push(`  -H '${authHeader}'`);
    if (hasBody) lines.push(`  -d '${json}'`);
    return lines.join(" \\\n");
  }

  if (lang === "javascript") {
    const headers = {};
    if (endpoint.method !== "GET") headers["Content-Type"] = "application/json";
    if (endpoint.auth) headers["X-ECC-Session"] = sessionToken;

    return `const response = await fetch("${requestUrl}", {
  method: "${endpoint.method}",
  credentials: "include",
  headers: ${JSON.stringify(headers, null, 2)}${hasBody ? `,
  body: JSON.stringify(${json})` : ""}
});

const data = await response.json();
console.log(data);`;
  }

  if (lang === "python") {
    const headers = {};
    if (endpoint.method !== "GET") headers["Content-Type"] = "application/json";
    if (endpoint.auth) headers["X-ECC-Session"] = sessionToken;

    return `import requests

url = "${requestUrl}"
headers = ${pythonObject(headers)}
${hasBody ? `payload = ${pythonObject(body)}\n` : ""}
response = requests.${endpoint.method.toLowerCase()}(
    url,
    headers=headers${hasBody ? ",\n    json=payload" : ""}
)

print(response.json())`;
  }

  if (lang === "php") {
    return `<?php
$url = "${requestUrl}";
$ch = curl_init($url);

curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_CUSTOMREQUEST, "${endpoint.method}");
${endpoint.auth ? `curl_setopt($ch, CURLOPT_HTTPHEADER, [
    "Content-Type: application/json",
    "X-ECC-Session: ${sessionToken}"
]);` : endpoint.method !== "GET" ? `curl_setopt($ch, CURLOPT_HTTPHEADER, ["Content-Type: application/json"]);` : ""}
${hasBody ? `curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode(${phpObject(body)}));` : ""}

$response = curl_exec($ch);
curl_close($ch);

echo $response;`;
  }

  if (lang === "csharp") {
    return `using System.Net.Http;
using System.Text;

var client = new HttpClient();
${endpoint.auth ? `client.DefaultRequestHeaders.Add("X-ECC-Session", "${sessionToken}");` : ""}

var request = new HttpRequestMessage(
    HttpMethod.${httpMethodCSharp(endpoint.method)},
    "${requestUrl}"
);
${hasBody ? `
request.Content = new StringContent(
    @"${escapeCSharp(json)}",
    Encoding.UTF8,
    "application/json"
);` : ""}

var response = await client.SendAsync(request);
var content = await response.Content.ReadAsStringAsync();

Console.WriteLine(content);`;
  }

  return `import java.net.URI;
import java.net.http.*;
${hasBody ? `\nString body = """\n${json}\n""";` : ""}

HttpRequest request = HttpRequest.newBuilder()
    .uri(URI.create("${requestUrl}"))
    ${endpoint.auth ? `.header("X-ECC-Session", "${sessionToken}")\n    ` : ""}${endpoint.method !== "GET" ? `.header("Content-Type", "application/json")\n    ` : ""}.${endpoint.method === "GET" ? "GET()" : `method("${endpoint.method}", HttpRequest.BodyPublishers.${hasBody ? "ofString(body)" : "noBody()"})`}
    .build();

HttpResponse<String> response = HttpClient.newHttpClient()
    .send(request, HttpResponse.BodyHandlers.ofString());

System.out.println(response.body());`;
}

function httpMethodCSharp(method) {
  return ({
    GET: "Get",
    POST: "Post",
    PUT: "Put",
    DELETE: "Delete"
  })[method] || "Post";
}

function escapeCSharp(text) {
  return text.replace(/"/g, '""');
}

function pythonObject(value) {
  return JSON.stringify(value, null, 4)
    .replace(/\btrue\b/g, "True")
    .replace(/\bfalse\b/g, "False")
    .replace(/\bnull\b/g, "None");
}

function phpObject(value) {
  if (Array.isArray(value)) {
    return `[${value.map((v) => phpObject(v)).join(", ")}]`;
  }
  if (value && typeof value === "object") {
    return `[${Object.entries(value)
      .map(([k, v]) => `"${k}" => ${phpObject(v)}`)
      .join(", ")}]`;
  }
  if (typeof value === "string") return `"${value.replace(/"/g, '\\"')}"`;
  if (value === null) return "null";
  return String(value);
}

function routeFor(key) {
  return ({
    overview: "",
    quickstart: "quickstart",
    authentication: "authentication",
    downloads: "resources",
    login: "auth/login",
    me: "auth/me",
    logout: "auth/logout",
    noncash: "payments/non-cash-sale",
    charge: "cash/charge",
    status: "cash/status",
    finalize: "cash/finalize",
    cancel: "cash/cancel",
    device: "device/status",
    mixed: "guides/mixed-payments",
    reverse: "guides/reverse-api",
    operationstatus: "reference/operation-status",
    responses: "reference/responses",
    errors: "reference/errors"
  })[key] || "";
}

function resolvePage(pathname) {
  const path = pathname.replace(/\/+$/, "");

  if (path.endsWith("/quickstart")) return "quickstart";
  if (path.endsWith("/authentication")) return "authentication";
  if (path.endsWith("/resources")) return "downloads";
  if (path.endsWith("/auth/login")) return "login";
  if (path.endsWith("/auth/me")) return "me";
  if (path.endsWith("/auth/logout")) return "logout";
  if (path.endsWith("/payments/non-cash-sale")) return "noncash";
  if (path.endsWith("/cash/charge")) return "charge";
  if (path.endsWith("/cash/status")) return "status";
  if (path.endsWith("/cash/finalize")) return "finalize";
  if (path.endsWith("/cash/cancel")) return "cancel";
  if (path.endsWith("/device/status")) return "device";
  if (path.endsWith("/guides/mixed-payments")) return "mixed";
  if (path.endsWith("/guides/reverse-api")) return "reverse";
  if (path.endsWith("/reference/operation-status")) return "operationstatus";
  if (path.endsWith("/reference/responses")) return "responses";
  if (path.endsWith("/reference/errors")) return "errors";

  return "overview";
}
